var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLastMinutePromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10233_20787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 56C41.2548 56 52 45.2548 52 32C52 18.7452 41.2548 8 28 8C14.7452 8 4 18.7452 4 32C4 45.2548 14.7452 56 28 56Z",
    fill: "#B3D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6478 1.59011C16.4268 3.05242 15.8729 4.86935 14.4105 5.64835C10.9385 7.49795 7.84025 9.97651 5.27361 12.9579C4.19261 14.2135 2.2984 14.3551 1.04276 13.2742C-0.212885 12.1932 -0.354476 10.299 0.726507 9.04331C3.77805 5.49871 7.46157 2.55189 11.5896 0.352853C13.0519 -0.426138 14.8688 0.127803 15.6478 1.59011ZM40.3525 1.59011C41.1313 0.127803 42.9481 -0.426138 44.4104 0.352853C48.5384 2.55189 52.222 5.49871 55.2737 9.04331C56.3545 10.299 56.2128 12.1932 54.9572 13.2742C53.7016 14.3551 51.8076 14.2135 50.7264 12.9579C48.1596 9.97651 45.0616 7.49795 41.5896 5.64835C40.1273 4.86935 39.5733 3.05242 40.3525 1.59011ZM30.5001 20.0006C30.5001 18.6199 29.3808 17.5006 28.0001 17.5006C26.6193 17.5006 25.5001 18.6199 25.5001 20.0006V32.0006C25.5001 33.3813 26.6193 34.5006 28.0001 34.5006H38C39.3808 34.5006 40.5 33.3813 40.5 32.0006C40.5 30.6199 39.3808 29.5006 38 29.5006H30.5001V20.0006Z",
    fill: "#5D89EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10233_20787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastMinutePromotion);
export default __webpack_public_path__ + "static/media/last-minute-promotion.0397c95a.svg";
export { ForwardRef as ReactComponent };